<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/hsHKiA/tc-custom/9781488079146.jpg?1703426607548" alt="This image is the cover for the book Bidding on the Bachelor, Saved by the Blog"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Bidding on the Bachelor, Saved by the Blog
      </h1>
      <p class="bookDescription body article font2">
        <b>In this romantic comedy, a woman returns to her small seaside hometown and reunites with her high school sweetheart.</b><br/><br/>Bayside High’s favorite It Girl is back in town and single again. No one would have bet Carissa Blackwell would ever return. Ten years ago, she crushed her high school boyfriend Jasper Dumont’s heart under her Jimmy Choos and left town for a bigger, better life in Chicago. Her return raises one question: What is she running from? Or more precisely, who is she running to?<br/><br/>Perhaps Jasper knows the answer to that question. Or not. One look at Carissa and he fell in the bay! That icy plunge should have brought the rich, single and devastatingly handsome bachelor to his senses. Yet the couple have been spotted together all over town ever since. Does this mean Bayside’s legendary couple may reunite? The stakes are high, but everyone in the small town is betting on love.<br/><br/>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Kerri Carpenter
      </h2>
      
      <p class="authorDescription body article">Award-winning romance author Kerri Carpenter writes contemporary romances that are sweet, sexy, and sparkly. When she&rsquo;s not writing, Kerri enjoys reading, cooking, watching movies, taking Zumba classes, rooting for Pittsburgh sports teams, and anything sparkly. Kerri lives in Northern Virginia with her adorable (and mischievous) rescued poodle mix, Harry.<Br><Br>Kerri loves chatting with readers. Visit her at kerricarpenter.com or on Facebook, Twitter or Instagram to connect today.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7bc5f8aa